import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { map, publishReplay, refCount, startWith } from 'rxjs/operators';
import { AppConfigService } from '../../app-config.service';
import { AccessService, Feature, StubAccessService } from '../../core/access';
import { UrlService } from '../../core/url.service';
import { UserBrandingService } from '../../core/user-branding.service';

const VENDASTA_LOGO = 'https://vstatic-prod.apigateway.co/partner-center-client.9223372035140951389.prod/assets/images/vendasta-logo.png';
const DEFAULT_LOGO =
  'https://vstatic-prod.apigateway.co/partner-center-client.9223372035140951389.prod/assets/images/powered-by-vendasta-logo.png';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
})
export class LogoComponent implements OnInit {
  whiteLabelLogoUrlDisplay$: Observable<string>;
  shouldShowEditCapability$: Observable<boolean>;
  shouldShowAddLogo$: Observable<boolean>;
  shouldShowPoweredByVendasta$: Observable<boolean>;
  isSuperAdminRoute$: Observable<boolean>;

  vendastaLogo = VENDASTA_LOGO;
  hoveringLogo = false;

  constructor(
    @Inject(StubAccessService) private access: AccessService,
    private urlService: UrlService,
    private readonly configService: AppConfigService,
    private userBrandingService: UserBrandingService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.isSuperAdminRoute$ = this.urlService.isSuperAdminRoute$;

    const hasWhitelabel$ = this.access.hasAccessToFeature(Feature.whitelabel).pipe(startWith(true));

    this.whiteLabelLogoUrlDisplay$ = combineLatest([this.userBrandingService.branding$, hasWhitelabel$]).pipe(
      map(([branding, hasWhitelabel]) => {
        if (!hasWhitelabel) {
          return DEFAULT_LOGO;
        }
        return branding.logoUrl;
      }),
      publishReplay(1),
      refCount(),
    );

    const userCanCustomizeWhitelabel$ = this.configService.config$.pipe(
      map((config) => {
        return config.userCanCustomizeWhitelabel;
      }),
    );

    this.shouldShowEditCapability$ = userCanCustomizeWhitelabel$;
    this.shouldShowAddLogo$ = combineLatest([
      hasWhitelabel$,
      this.whiteLabelLogoUrlDisplay$,
      userCanCustomizeWhitelabel$,
    ]).pipe(
      map(
        ([hasWhitelabel, logoUrl, userCanCustomizeWhitelabel]) =>
          hasWhitelabel && !logoUrl && userCanCustomizeWhitelabel,
      ),
    );

    this.shouldShowPoweredByVendasta$ = this.access
      .hasAccessToFeature(Feature.cobrandingDisabled)
      .pipe(map((cobrandingDisabled) => !cobrandingDisabled));
  }

  editLogo(): void {
    this.router.navigateByUrl('/customize-branding');
  }
}
